import { CASEBUSI_MNG } from '@/api/apiModules'
export default {
  viewType: 'detail',
  toolbar: {
    hasRefresh: false
  },
  class: 'wsp-cusotm-dialog-detail-page-view',
  view: {
    tabs: [
      {
        label: 'baseInfo',
        viewMetaData: {
          module: CASEBUSI_MNG,
          params: null,
          fillDetailUrl: `${CASEBUSI_MNG}/detail`,
          viewType: 'form',
          cb() {},
          view: {
            isSimple: false,
            labelWidth: '140px',
            header: {},
            content: [
              {
                isGroup: true,
                $type: 'group',
                $id: 'base',
                title: 'overview',
                icon: 'sk-icon-overview',
                $items: [
                  {
                    $id: 'testCaseCode',
                    label: 'testcaseMng.testCaseCode'
                  },
                  {
                    $id: 'testCaseName',
                    label: 'testcaseMng.testCaseName'
                  },
                  {
                    $id: 'testCaseContent',
                    label: 'testcaseMng.testCaseContent'
                  },
                  {
                    $id: 'testCaseScene',
                    label: 'testcaseMng.testCaseScene'
                  },
                  {
                    $id: 'userDemand',
                    label: 'testcaseMng.testUserDemand'
                  },
                  {
                    $id: 'testCaseStep',
                    label: 'testcaseMng.testCaseStep',
                    dataType: 'custom',
                    custom: function(data, h) {
                      if (!data || !data.testCaseStep) {
                        return
                      }
                      let testCaseStep = data.testCaseStep.replace(/\n\s*\n/g, '\n')
                      return <div class="wsp-word-break">{testCaseStep}</div>
                    }
                  },
                  {
                    $id: 'compatibleDTOList',
                    label: '产品&操作系统',
                    dataType: 'custom',
                    custom: function(data, h) {
                      if (!data || !data.compatibleDTOList || data.compatibleDTOList.length == 0) {
                        return
                      }
                      const renderItem = []
                      data.compatibleDTOList.forEach(el => {
                        renderItem.push(
                          <div>
                            <el-tag type="success" class="wsp-margin-left-3 wsp-margin-top-3">
                              【{el.productVersion} / {el.os}】
                            </el-tag>
                          </div>
                        )
                      })

                      return renderItem
                    }
                  },
                  {
                    $id: 'testCaseExpectedResult',
                    label: 'testcaseMng.testCaseExpectedResult'
                  },
                  {
                    $id: 'createTime',
                    label: '创建时间',
                    dataType: 'date'
                  },
                  {
                    $id: 'relationFeatureList',
                    label: '关联功能',
                    dataType: 'custom',
                    custom: function(data, h) {
                      if (!data || !data.relationFeatureList || data.relationFeatureList.length == 0) {
                        return
                      }
                      const renderItem = []
                      data.relationFeatureList.forEach(el => {
                        renderItem.push(
                          <div class="wsp-margin-left-3 wsp-margin-top-3">
                            <span>
                              {el.featureName}【{el.featureCode}】
                            </span>
                          </div>
                        )
                      })
                      return renderItem
                    }
                  }
                ]
              }
            ]
          }
        }
      }
    ]
  }
}
